import { Identifiable, List } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleRemoveMilestone(
  list: Identifiable<List>,
  milestone: Boundaries["removeMilestone"]["success"],
): Identifiable<List> {
  return {
    ...list,
    milestones: list.milestones.filter(({ uuid }) => milestone.uuid !== uuid),
    subLists: list.subLists.map((subList) =>
      handleRemoveMilestone(subList, milestone),
    ),
  };
}
export { handleRemoveMilestone };
